import React from 'react';

import {LinearProgress, Box} from '@mui/material';

import styles from './Loader.module.css'

const Loader = props => {
    return <Box className={styles.container}>
        <LinearProgress color='primary' />
    </Box>
}

export default Loader;